import { SetStateAction, useEffect, useState, useCallback } from "react";
import { Input, Button, Tooltip, Table, Space, Popconfirm } from "antd";
import { Trash, Refresh2 } from "iconsax-react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import PageHeader from "../../../components/PageHeader";

import {
  Container,
  Main,
  SearchBar,
  Content,
  HeaderContent,
  ActionsWrapper,
  TableWrapper,
} from "./styles";
import { useProfiles, DataTypeProfile } from "../../../hooks/profile";
import { useAuth } from "../../../hooks/auth";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../components/Breadcrumb";

function StudentList() {
  const navigate = useNavigate();
  const { getStudents, deleteProfile } = useProfiles();
  const { user } = useAuth();

  useEffect(() => {
    if (user && user.type !== "admin" && !user.isAdmin) {
      navigate("/403");
    }
  }, [user, navigate]);
  const [busca, setBusca] = useState("");
  const [data, setData] = useState<DataTypeProfile[]>([]);
  const [loading, setLoading] = useState(false);

  const handleGetStudents = useCallback(async () => {
    Swal.fire({
      title: "Carregando...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: async () => {
        Swal.showLoading();
        setLoading(true);
        try {
          const listagemDeAlunos = await getStudents();
          setData(listagemDeAlunos);
          setLoading(false);
          Swal.close();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Ocorreu um erro ao listar os alunos",
            text: "Tente novamente mais tarde",
            confirmButtonText: "Tentar novamente",
            confirmButtonColor: "var(--color-primary-light)",
          });
          setLoading(false);
          console.log(error);
        }
      },
    });
  }, [getStudents]);

  const studentsWithSearch = data.filter(
    (current: DataTypeProfile): boolean => {
      return current.name?.toUpperCase().includes(busca.toLocaleUpperCase());
    }
  );

  async function handleDeleteStudent(uid: string) {
    await deleteProfile(uid);
    handleGetStudents();
  }

  useEffect(() => {
    handleGetStudents();
  }, [handleGetStudents]);

  const columns = [
    {
      title: "Nome do aluno",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Ações",
      dataIndex: "",
      key: "x",
      render: (record: DataTypeProfile) => {
        return (
          <Space size="middle">
            <Popconfirm
              title="Deseja realmente apagar?"
              okText="Sim"
              cancelText="Não"
              onConfirm={() => {
                handleDeleteStudent(record.uid).catch(console.error);
              }}
            >
              <Button shape="circle" danger>
                <Trash size={16} />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  return (
    <Container id="page">
      <PageHeader
        title="Gerenciamento de Alunos."
        description="Estes são todos os alunos cadastrados no Bilíngua"
        type="manager"
      />
      <Main>
        <Breadcrumb
          items={[
            { label: "Gerenciamento", link: "/manager" },
            { label: "Alunos", active: true },
          ]}
        />
        <SearchBar className="search">
          <Input
            placeholder="Digite um termo para buscar"
            type="text"
            size="large"
            allowClear
            value={busca}
            onChange={(e: { target: { value: SetStateAction<string> } }) => {
              setBusca(e.target.value);
            }}
            style={{ height: "6rem", marginRight: "2rem" }}
          />
          <Button
            type="primary"
            htmlType="button"
            style={{
              border: "0",
              backgroundColor: "var(--color-secondary-dark)",
              width: "15rem",
              height: "5rem",
              borderRadius: "0.8rem",
            }}
          >
            Buscar
          </Button>
        </SearchBar>

        <Content className="content" style={{ padding: 30 }}>
          <HeaderContent className="headerContent">
            Lista de alunos cadastrados
            <span />
            <br />
            <ActionsWrapper className="itens">
              <Tooltip title="Cadastre um Novo Aluno">
                <Button
                  type="primary"
                  htmlType="button"
                  style={{
                    border: "0",
                    backgroundColor: "var(--color-secondary-dark)",
                    borderRadius: "0.8rem",
                  }}
                  onClick={() => navigate("/new-student")}
                >
                  + Adicionar novo aluno
                </Button>
              </Tooltip>
              <Button
                onClick={() => {
                  handleGetStudents().catch(console.error);
                }}
                icon={<Refresh2 size={18} />}
                loading={loading}
              />
            </ActionsWrapper>
          </HeaderContent>

          <TableWrapper className="table">
            <Table
              rowSelection={{
                type: "checkbox",
                onSelect: (record) => {
                  console.log(record);
                },
              }}
              columns={columns}
              dataSource={studentsWithSearch}
              pagination={{ hideOnSinglePage: true }}
              rowKey="uid"
            />
          </TableWrapper>
        </Content>
      </Main>
      <Footer />
    </Container>
  );
}

export default StudentList;
